"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Accordion = _interopRequireDefault(require("01_core/components/layout/Accordion"));
var _ListTable = _interopRequireDefault(require("01_core/components/layout/module/ListTable"));
var _CLink = _interopRequireDefault(require("01_core/components/materials/CLink"));
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _coreConfirmActions = require("01_core/reducers/coreConfirmActions");
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KansaAnswerBcpTrailEntry = _interopRequireDefault(require("./components/KansaAnswerBcpTrailEntry"));
var _KansaAnswerTrailEntry = _interopRequireDefault(require("./components/KansaAnswerTrailEntry"));
var _kansaAnswerActions = require("./kansaAnswerActions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledCardActions = (0, _styles.styled)(_material.CardActions)(_ref => {
  let {
    theme
  } = _ref;
  return {
    textAlign: 'right',
    paddingTop: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(2)
  };
});

/**
 * 監査回答登録画面　証跡一覧
 */
function KansaAnswerTrailList(props) {
  const {
    callAPI,
    callAPIRawResponse,
    kansaInfo,
    openInfoBar,
    setSearchTrailResult,
    openConfirm,
    intl,
    searchTrailResult,
    gyomuCd
  } = props;
  (0, _react.useEffect)(() => {
    window.scrollTo(0, 0);
    searchTrailData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * 監査証跡情報検索処理
   */
  const searchTrailData = (0, _react.useCallback)(() => {
    callAPI(_APIs.KANSA_ANSWER_TRAIL_SEARCH, {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId
    }).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        setSearchTrailResult(response.data);
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, response.message);
      }
    });
  }, [callAPI, kansaInfo, setSearchTrailResult, openInfoBar]);

  /**
   * 削除
   */
  const onDeleteClick = (0, _react.useCallback)(eviNo => {
    const sendData = {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
      eviNo
    };
    callAPI(_APIs.KANSA_ANSWER_TRAIL_FILE_DELETE, sendData).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        // 監査証跡情報
        searchTrailData();
      }
    });
  }, [callAPI, kansaInfo, searchTrailData]);

  /**
   * 削除確認ダイアログ
   */
  const openDeleteDialog = (0, _react.useCallback)(eviNo => {
    openConfirm(intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CONFIRM
    }), intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_DELETE_CONFIRM_TRAIL_MESSAGE
    }), () => onDeleteClick(eviNo));
  }, [openConfirm, intl, onDeleteClick]);

  // 証跡ファイルリンク押下ダウンロードハンドラ
  const fileDownload = (0, _react.useCallback)((eviNo, fileNm) => {
    const sendData = {
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
      eviNo,
      fileNm
    };
    callAPIRawResponse(_APIs.KANSA_ANSWER_TRAIL_FILE_DOWNLOAD, sendData).then(response => response.blob()).then(blob => {
      if (blob.size > 0) {
        let anchor = document.createElement('a');
        anchor.download = fileNm;
        anchor.href = window.URL.createObjectURL(blob);
        anchor.click();
      } else {
        openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
          id: _labelConsts.LABEL.CORE_FILE_NOT_FOUND_MESSAGE
        }));
      }
    });
  }, [callAPIRawResponse, kansaInfo, intl, openInfoBar]);

  // 証跡登録ハンドラ
  const trailRegistHandle = (0, _react.useCallback)(() => {
    searchTrailData();
  }, [searchTrailData]);

  // 検索結果ヘッダ（証跡情報）
  const columns = [{
    dataKey: 'updateBtn',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_UPDATE
    }),
    width: 50,
    minWidth: 50,
    maxWidth: 50
  }, {
    dataKey: 'deleteBtn',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_DELETE
    }),
    width: 50,
    minWidth: 50,
    maxWidth: 50
  }, {
    dataKey: 'eviDocNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_TRAIL_NAME
    }),
    width: 700,
    minWidth: 50,
    maxWidth: 700
  }, {
    dataKey: 'fileNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_FILE
    }),
    width: 400,
    minWidth: 80,
    maxWidth: 400
  }, {
    dataKey: 'updUserNm',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_REGISTERED_PERSON
    }),
    width: 400,
    minWidth: 80,
    maxWidth: 400
  }, {
    dataKey: 'updDt',
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_REGISTERED_DATE
    }),
    width: 300,
    minWidth: 80,
    maxWidth: 300
  }];

  // 検索結果ボディ
  const createRow = data => {
    const updateBtn = /*#__PURE__*/_react.default.createElement(_KansaAnswerTrailEntry.default, {
      buttonFlg: false,
      kansaTgtNendo: kansaInfo.kansaTgtNendo,
      kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
      eviNo: data.eviNo,
      eviDocNm: data.eviDocNm,
      eviFileNm: data.fileNm,
      onChange: trailRegistHandle
    });
    const deleteBtn = /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
      action: "delete",
      onClick: () => {
        openDeleteDialog(data.eviNo);
      }
    });
    const eviDocNm = _stringUtil.default.emptyToHyphen(data.eviDocNm);
    const fileNm = data.fileNm !== '' ? /*#__PURE__*/_react.default.createElement(_CLink.default, {
      onClick: () => {
        fileDownload(data.eviNo, data.fileNm);
      }
    }, _stringUtil.default.emptyToHyphen(data.fileNm)) : _stringUtil.default.emptyToHyphen(data.fileNm);
    const updUserNm = _stringUtil.default.emptyToHyphen(data.updUserNm);
    const updDt = _stringUtil.default.emptyToHyphen(data.updDt);
    return {
      updateBtn,
      deleteBtn,
      eviDocNm,
      fileNm,
      updUserNm,
      updDt
    };
  };
  return /*#__PURE__*/_react.default.createElement(_Accordion.default, {
    title: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_TRAIL
    })
  }, searchTrailResult.length === 0 ? /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "body2"
  }, intl.formatMessage({
    id: _labelConsts.LABEL.KANSA_INSERT_CONFIRM_TRAIL_MESSAGE
  })) : /*#__PURE__*/_react.default.createElement(_ListTable.default, {
    rowData: searchTrailResult,
    autoWidth: true,
    height: 178,
    headerHeight: 45,
    columns,
    createRow
  }), /*#__PURE__*/_react.default.createElement(StyledCardActions, {
    disableSpacing: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "div",
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_KansaAnswerBcpTrailEntry.default, {
    gyomuCd: gyomuCd,
    kansaTgtNendo: kansaInfo.kansaTgtNendo,
    kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
    onChange: trailRegistHandle,
    autoWidth: true
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "div",
    variant: "body2"
  }, /*#__PURE__*/_react.default.createElement(_KansaAnswerTrailEntry.default, {
    buttonFlg: true,
    kansaTgtNendo: kansaInfo.kansaTgtNendo,
    kansaTgtJigyoId: kansaInfo.kansaTgtJigyoId,
    onChange: trailRegistHandle,
    autoWidth: true
  }))));
}
const mapStateToProps = state => {
  return {
    kansaInfo: state.kansaAnswer.kansaInfo,
    searchTrailResult: state.kansaAnswer.searchTrailResult,
    gyomuCd: state.kansaAnswer.searchConditions.gyomuCd
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setSearchTrailResult: resultList => dispatch(_kansaAnswerActions.kansaAnswerActions[_kansaAnswerActions.TYPES.SET_SEARCH_TRAIL_RESULT](resultList)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CodeUtil.withCodeUtil)(KansaAnswerTrailList))));